import { get, post, put } from '@/api/apiClient';

export const fetchCart = () => get<CartDto>('ecom/cart/owner/me');

export const createCart = (cart: CartMutable) =>
  post<CartDto>('ecom/cart', cart);

export const updateCart = (cart: CartMutable) =>
  put<CartDto>('ecom/cart/owner/me', cart);
